import {createContext, useContext} from 'react';
import backendApiService from '../service/backend-api.service';

const AccountViewContext=createContext({api:backendApiService,readOnly:false,
  orderPath:order=>order.source==='bot'?`/account/orders/${order.shop}/${order.billId}`:`/store/order/${order.orderId}`});
export const AccountViewProvider=AccountViewContext.Provider;
export const useAccountView=()=>useContext(AccountViewContext);
